import React, { useEffect, useState } from 'react';

import useCart from 'utils/eCommerce/cart/useCart';

import {
  AlertWrapper,
  DetailsWrapper,
  Discount,
  RxNotice,
  Subtotal,
  Total,
} from './Details.style';
import { EcommerceCTA } from '.';
import { EVENTS } from 'consts/metricsTrackingEvents';

export const Details = () => {
  const {
    cart: {
      containsRx,
      cartAlert,
      checkoutUrl,
      items,
      total,
      baseAmount,
      cartAmount,
    },
  } = useCart();
  const [showCartAlert, setShowCartAlert] = useState('');
  const subtotalValue = baseAmount ?? total;
  const itemDiscountValue = items.reduce(
    (sum, item) => sum + item.discountAmount + item.couponAmount,
    0,
  );
  const discountValue =
    cartAmount !== undefined && cartAmount !== null
      ? Math.max(0, subtotalValue - cartAmount)
      : itemDiscountValue;
  const totalValue =
    cartAmount !== undefined && cartAmount !== null
      ? cartAmount
      : Math.max(0, subtotalValue - discountValue);
  const hasDiscount = discountValue > 0.005;

  useEffect(() => {
    if (cartAlert) {
      setShowCartAlert(cartAlert);
    }
  }, [cartAlert]);

  return (
    <DetailsWrapper>
      <Subtotal value={subtotalValue} />
      {hasDiscount && (
        <React.Fragment>
          <Discount value={discountValue} />
          <Total value={totalValue} />
        </React.Fragment>
      )}
      <p> Shipping &amp; Taxes calculated at checkout </p>
      {showCartAlert !== '' && <AlertWrapper alertText={showCartAlert} />}
      {containsRx && <RxNotice />}
      <EcommerceCTA
        containsRx={containsRx}
        href={checkoutUrl}
        trackingEvent={EVENTS.ctaClicked}
      >
        Checkout
      </EcommerceCTA>
    </DetailsWrapper>
  );
};
